import React, { useState } from "react";
import {
  showErrorToaster as showErrorToastImport,
  showToaster,
} from "../State/actions/toaster";
import { connect } from "react-redux";
import ModalPopup from "../components/ModalPopup";

const styles = {
  container: {
    marginTop: "3rem",
    animation: "fadeIn 0.5s ease-in-out",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: "600",
    textAlign: "center",
  },
  grid: {
    display: "grid",
    gap: "1.5rem",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  },
  card: {
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease-in-out",
  },
  header: {
    position: "relative",
    height: "160px",
    background: "linear-gradient(to right, #3b82f6, #1e3a8a)",
    overflow: "hidden",
  },
  backgroundImage: (url) => ({
    position: "absolute",
    inset: 0,
    backgroundImage: `url(${url})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    mixBlendMode: "overlay",
    opacity: "0.9",
  }),
  badge: {
    position: "absolute",
    bottom: "1rem",
    left: "1rem",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    padding: "6px 12px",
    borderRadius: "999px",
    fontSize: "0.875rem",
    fontWeight: "500",
  },
  content: {
    padding: "1.5rem",
  },
  name: {
    fontSize: "1.25rem",
    fontWeight: "700",
  },
  location: {
    color: "#6b7280",
  },
  rating: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: "#dbeafe",
    color: "#0055A5",
    padding: "4px 8px",
    borderRadius: "6px",
    height: "fit-content",
  },
  slots: {
    fontSize: "0.875rem",
    color: "#6b7280",
  },
  button: {
    width: "100%",
    padding: "10px 16px",
    fontSize: "0.875rem",
    borderRadius: "6px",
    cursor: "not-allowed",
    backgroundColor: "#DBE9FE",
    color: "#6b7280",
    border: "none",
  },
};

const specialists = [
  {
    name: "Dr. Sarah Johnson",
    location: "Fakeeh Care Group",
    rating: 4.9,
    image:
      "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=1000",
    slots: [
      {
        start: 1742963400000 + 86400000,
        end: 1742965200000 + 86400000,
        slotIds: ["67e2c34017e5ad0e6f5d8d6c"],
        templateId: "6726860223b1ad38ad0756d6",
        scheduleId: "67e2c31b17e5ad0e6f58ae50",
        participants: [
          {
            patientId: "6725117fa884f8552fec5b95",
            referenceType: "PATIENT",
          },
          {
            referenceType: "STAFF",
            staffId: "67e239a56a107141c8b87435",
            userId: "67e239a56a107141c8b87436",
            displayHumanName: {
              text: "Doctor (Dr) Sarah  Johnson ",
              family: "Johnson",
              given: "Sarah ",
              prefix: "Doctor (Dr)",
            },
            spaceRole: "ROLE_DOCTOR",
          },
        ],
        appointmentLocationMDLocation: {},
        appointmentLocationMDValue: {
          id: "67e3339517e5ad0e6f4cb15b",
        },
      },
      {
        start: 1742967000000 + 86400000,
        end: 1742968800000 + 86400000,
        slotIds: ["67e2c34017e5ad0e6f5d8d6e"],
        templateId: "6726860223b1ad38ad0756d6",
        scheduleId: "67e2c31b17e5ad0e6f58ae50",
        participants: [
          {
            patientId: "6725117fa884f8552fec5b95",
            referenceType: "PATIENT",
          },
          {
            referenceType: "STAFF",
            staffId: "67e239a56a107141c8b87435",
            userId: "67e239a56a107141c8b87436",
            displayHumanName: {
              text: "Doctor (Dr) Sarah  Johnson ",
              family: "Johnson",
              given: "Sarah ",
              prefix: "Doctor (Dr)",
            },
            spaceRole: "ROLE_DOCTOR",
          },
        ],
        appointmentLocationMDLocation: {},
        appointmentLocationMDValue: {
          id: "67e3339517e5ad0e6f4cb15b",
        },
      },
      {
        start: 1742972400000 + 86400000,
        end: 1742974200000 + 86400000,
        slotIds: ["67e2c34017e5ad0e6f5d8d71"],
        templateId: "6726860223b1ad38ad0756d6",
        scheduleId: "67e2c31b17e5ad0e6f58ae50",
        participants: [
          {
            patientId: "6725117fa884f8552fec5b95",
            referenceType: "PATIENT",
          },
          {
            referenceType: "STAFF",
            staffId: "67e239a56a107141c8b87435",
            userId: "67e239a56a107141c8b87436",
            displayHumanName: {
              text: "Doctor (Dr) Sarah  Johnson ",
              family: "Johnson",
              given: "Sarah ",
              prefix: "Doctor (Dr)",
            },
            spaceRole: "ROLE_DOCTOR",
          },
        ],
        appointmentLocationMDLocation: {},
        appointmentLocationMDValue: {
          id: "67e3339517e5ad0e6f4cb15b",
        },
      },
    ],
  },
  {
    name: "Dr. Ahmed Hassan",
    location: "Fakeeh Care Group",
    rating: 4.8,
    image:
      "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?q=80&w=1000",
    slots: [
      {
        start: 1742956200000 + 86400000,
        end: 1742958000000 + 86400000,
        slotIds: ["67e2b0a517e5ad0e6f1cf754"],
        templateId: "6726860223b1ad38ad0756d6",
        scheduleId: "67e2af5b17e5ad0e6ffcc0d8",
        participants: [
          {
            patientId: "6725117fa884f8552fec5b95",
            referenceType: "PATIENT",
          },
          {
            referenceType: "STAFF",
            staffId: "67e236eb6a107141c8a300be",
            userId: "67e236eb6a107141c8a300bf",
            displayHumanName: {
              text: "Doctor (Dr) Ahmed Hassan ",
              family: "Hassan",
              given: "Ahmed",
              prefix: "Doctor (Dr)",
            },
            spaceRole: "ROLE_DOCTOR",
          },
        ],
        appointmentLocationMDLocation: {},
        appointmentLocationMDValue: {
          id: "67e3353217e5ad0e6f5fb0ef",
        },
      },
      {
        start: 1742961600000 + 86400000,
        end: 1742963400000 + 86400000,
        slotIds: ["67e2b0a517e5ad0e6f1cf757"],
        templateId: "6726860223b1ad38ad0756d6",
        scheduleId: "67e2af5b17e5ad0e6ffcc0d8",
        participants: [
          {
            patientId: "6725117fa884f8552fec5b95",
            referenceType: "PATIENT",
          },
          {
            referenceType: "STAFF",
            staffId: "67e236eb6a107141c8a300be",
            userId: "67e236eb6a107141c8a300bf",
            displayHumanName: {
              text: "Doctor (Dr) Ahmed Hassan ",
              family: "Hassan",
              given: "Ahmed",
              prefix: "Doctor (Dr)",
            },
            spaceRole: "ROLE_DOCTOR",
          },
        ],
        appointmentLocationMDLocation: {},
        appointmentLocationMDValue: {
          id: "67e3353217e5ad0e6f5fb0ef",
        },
      },
      {
        start: 1742967000000 + 86400000,
        end: 1742968800000 + 86400000,
        slotIds: ["67e2b0a517e5ad0e6f1cf75a"],
        templateId: "6726860223b1ad38ad0756d6",
        scheduleId: "67e2af5b17e5ad0e6ffcc0d8",
        participants: [
          {
            patientId: "6725117fa884f8552fec5b95",
            referenceType: "PATIENT",
          },
          {
            referenceType: "STAFF",
            staffId: "67e236eb6a107141c8a300be",
            userId: "67e236eb6a107141c8a300bf",
            displayHumanName: {
              text: "Doctor (Dr) Ahmed Hassan ",
              family: "Hassan",
              given: "Ahmed",
              prefix: "Doctor (Dr)",
            },
            spaceRole: "ROLE_DOCTOR",
          },
        ],
        appointmentLocationMDLocation: {},
        appointmentLocationMDValue: {
          id: "67e3353217e5ad0e6f5fb0ef",
        },
      },
    ],
  },
  {
    name: "Dr. Fatima Al-Zahra",
    location: "Fakeeh Care Group",
    rating: 4.7,
    image:
      "https://images.unsplash.com/photo-1594824476967-48c8b964273f?q=80&w=1000",
    slots: [
      {
        start: 1742958000000 + 86400000,
        end: 1742959800000 + 86400000,
        slotIds: ["67e2b08a17e5ad0e6f12aefb"],
        templateId: "6726860223b1ad38ad0756d6",
        scheduleId: "67e2af9217e5ad0e6f010fe2",
        participants: [
          {
            patientId: "6725117fa884f8552fec5b95",
            referenceType: "PATIENT",
          },
          {
            referenceType: "STAFF",
            staffId: "67e1dd546a107141c84e66cf",
            userId: "67e1dd556a107141c84e66d0",
            displayHumanName: {
              text: "Doctor (Dr) Fatima Al-Zahra ",
              family: "Al-Zahra",
              given: "Fatima",
              prefix: "Doctor (Dr)",
            },
            spaceRole: "ROLE_DOCTOR",
          },
        ],
        appointmentLocationMDLocation: {},
        appointmentLocationMDValue: {
          id: "67e334cf17e5ad0e6f5a917f",
        },
      },
      {
        start: 1742958000000 + 86400000,
        end: 1742959800000 + 86400000,
        slotIds: ["67e2b08a17e5ad0e6f12aefb"],
        templateId: "6726860223b1ad38ad0756d6",
        scheduleId: "67e2af9217e5ad0e6f010fe2",
        participants: [
          {
            patientId: "6725117fa884f8552fec5b95",
            referenceType: "PATIENT",
          },
          {
            referenceType: "STAFF",
            staffId: "67e1dd546a107141c84e66cf",
            userId: "67e1dd556a107141c84e66d0",
            displayHumanName: {
              text: "Doctor (Dr) Fatima Al-Zahra ",
              family: "Al-Zahra",
              given: "Fatima",
              prefix: "Doctor (Dr)",
            },
            spaceRole: "ROLE_DOCTOR",
          },
        ],
        appointmentLocationMDLocation: {},
        appointmentLocationMDValue: {
          id: "67e334cf17e5ad0e6f5a917f",
        },
      },
      {
        start: 1743042600000 + 86400000,
        end: 1743044400000 + 86400000,
        slotIds: ["67e2b08a17e5ad0e6f12af0e"],
        templateId: "6726860223b1ad38ad0756d6",
        scheduleId: "67e2af9217e5ad0e6f010fe2",
        participants: [
          {
            patientId: "6725117fa884f8552fec5b95",
            referenceType: "PATIENT",
          },
          {
            referenceType: "STAFF",
            staffId: "67e1dd546a107141c84e66cf",
            userId: "67e1dd556a107141c84e66d0",
            displayHumanName: {
              text: "Doctor (Dr) Fatima Al-Zahra ",
              family: "Al-Zahra",
              given: "Fatima",
              prefix: "Doctor (Dr)",
            },
            spaceRole: "ROLE_DOCTOR",
          },
        ],
        appointmentLocationMDLocation: {},
        appointmentLocationMDValue: {
          id: "67e334cf17e5ad0e6f5a917f",
        },
      },
    ],
  },
];

const RecommendedSpecialists = ({ showToaster, showErrorToaster }) => {
  const [appointment, setAppointment] = useState(null);
  const [loading, setLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState({ title: "", message: "" });

  function formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const now = new Date();

    const isToday = date.toDateString() === now.toDateString();
    const isTomorrow =
      date.toDateString() ===
      new Date(now.setDate(now.getDate() + 1)).toDateString();

    const timeOptions = { hour: "numeric", minute: "2-digit", hour12: true };
    const formattedTime = new Intl.DateTimeFormat("en-US", timeOptions).format(
      date
    );

    if (isToday) {
      return `Today, ${formattedTime}`;
    } else if (isTomorrow) {
      return `Tomorrow, ${formattedTime}`;
    } else {
      const dateOptions = { weekday: "long", month: "short", day: "numeric" };
      const formattedDate = new Intl.DateTimeFormat(
        "en-US",
        dateOptions
      ).format(date);
      return `${formattedDate}, ${formattedTime}`;
    }
  }

  const onBookingAppointment = async () => {
    setLoading(true);
    try {
      await fetch(
        "https://api.mypatientspace.com/api/signup/appointmentsFromTemplate?uid=6725117fa884f8552fec5b97&pid=6725117fa884f8552fec5b95",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(appointment),
        }
      );

      setModalData({
        title: "Appointment Created",
        message: `Appointment has been created. ${formatTimestamp(
          appointment.start
        )}.`,
      });
    } catch (err) {
      console.log(err);
      setModalData({
        title: "Appointment Failed",
        message: `Failed to create appointment. ${formatTimestamp(
          appointment.start
        )}.`,
      });
    } finally {
      setLoading(false);
      setModalOpen(true);
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    setAppointment(null);
  };

  return (
    <div style={styles.container}>
      <h3 style={styles.title} className="my-5">
        Recommended Specialists
      </h3>
      <div style={styles.grid}>
        {specialists.map((specialist, index) => (
          <div key={index} style={styles.card}>
            <div style={styles.header}>
              <div style={styles.backgroundImage(specialist.image)}></div>
              <div style={styles.badge}>COPD Specialist</div>
            </div>
            <div style={styles.content}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <h3 style={styles.name}>{specialist.name}</h3>
                  <p style={styles.location}>{specialist.location}</p>
                </div>
                <div style={styles.rating}>
                  <span>⭐</span>
                  <span>{specialist.rating}</span>
                </div>
              </div>
              <div>
                <h4 style={styles.slots}>Available Slots</h4>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {specialist.slots.map((slot, i) => (
                    <button
                      onClick={() => setAppointment(slot)}
                      key={i}
                      style={
                        appointment === slot
                          ? {
                              ...styles.button,
                              cursor: "pointer",
                              border: "solid",
                              borderColor: "#0055A4",
                              fontWeight: "bold",
                            }
                          : { ...styles.button, cursor: "pointer" }
                      }
                    >
                      {formatTimestamp(slot.start)}
                    </button>
                  ))}
                </div>
              </div>
              <button
                style={
                  !specialist.slots.some((slot) => slot === appointment)
                    ? { ...styles.button, background: "#e3dfde" }
                    : {
                        ...styles.button,
                        background: "#0055A4",
                        color: "white",
                        cursor: "pointer",
                      }
                }
                disabled={
                  !specialist.slots.some((slot) => slot === appointment) ||
                  loading
                }
                className="mt-2"
                onClick={onBookingAppointment}
              >
                Book Appointment
              </button>
            </div>
          </div>
        ))}
      </div>
      {modalOpen && (
        <ModalPopup
          title={modalData.title}
          onClose={closeModal}
          className="myp-modal"
        >
          <div style={{ padding: "1rem", textAlign: "center" }}>
            <p>{modalData.message}</p>
            <button
              onClick={closeModal}
              style={{
                padding: "10px 20px",
                border: "none",
                borderRadius: "6px",
                background: "#0055A4",
                color: "white",
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </div>
        </ModalPopup>
      )}
    </div>
  );
};

const mapDispatchToProps = {
  showToaster,
  showErrorToaster: showErrorToastImport,
};

export default connect(null, mapDispatchToProps)(RecommendedSpecialists);
